import { useEffect, useState } from 'react'
import { engineRulesAPI, type EngineRules } from '../services/api'

/**
 * The engine's publish rules from GET /api/public/engine-rules. null until it
 * answers, and stays null if it fails: callers then state the rule without
 * its number rather than inventing one.
 */
export const useEngineRules = (): EngineRules | null => {
  const [rules, setRules] = useState<EngineRules | null>(null)
  useEffect(() => {
    let active = true
    Promise.resolve(engineRulesAPI?.get?.())
      .then((value) => {
        if (active && value) setRules(value)
      })
      .catch((error) => {
        console.error('Engine rules failed to load:', error)
      })
    return () => {
      active = false
    }
  }, [])
  return rules
}

/** The "cost_floor" gate's label. The key predates the rule; the label is the rule. */
export const stopTooTightLabel = (rules: EngineRules | null) =>
  rules ? `Stop too tight (< ${rules.min_stop_distance_pct}%)` : 'Stop too tight'
